var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8064 2.43634C13.8064 2.43634 15.1015 1.93134 14.9936 3.15777C14.9576 3.66278 14.6339 5.43028 14.382 7.34208L13.5186 13.0053C13.5186 13.0053 13.4467 13.8349 12.7991 13.9792C12.1516 14.1235 11.1803 13.4742 11.0004 13.3299C10.8565 13.2217 8.30227 11.5985 7.40287 10.8049C7.15103 10.5885 6.86323 10.1556 7.43883 9.65064L11.2162 6.04351C11.6479 5.61064 12.0796 4.60064 10.2809 5.82708L5.24437 9.25388C5.24437 9.25388 4.66877 9.61458 3.58953 9.28994L1.25114 8.56851C1.25114 8.56851 0.387737 8.02744 1.86272 7.48634C5.46023 5.79098 9.88517 4.05954 13.8064 2.43634Z",
    fill: "rgba(0, 0, 0, 0.54)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.641247aafc616828f7499f405b66f72d.svg";
export { ForwardRef as ReactComponent };